/* ==========================================================================
   ATTITUDE — Shared site behavior
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initPreloader();
  initScrollReveal();
  initScrollMarker();
  initCartDrawer();
  initHeroParallax();
  initYear();
  initImageFallback();
});

/* ---- Hide the broken-image icon if a product/CDN image fails to load,
   leaving the frame's background color as a clean fallback instead ---- */
function initImageFallback() {
  document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('error', () => {
      img.style.opacity = '0';
    }, { once: true });
  });
}

/* ---- Preloader: brief brand moment before the hero is shown ---- */
function initPreloader() {
  const pre = document.querySelector('.preloader');
  const hero = document.querySelector('.hero');
  if (!pre) return;
  window.setTimeout(() => {
    pre.classList.add('is-done');
    if (hero) hero.classList.add('is-loaded');
    pre.addEventListener('transitionend', () => pre.remove(), { once: true });
  }, 700);
}

/* ---- Scroll reveal for any [data-reveal] element ---- */
function initScrollReveal() {
  const targets = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window) || !targets.length) {
    targets.forEach((t) => t.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.revealDelay || 0;
          window.setTimeout(() => entry.target.classList.add('is-visible'), delay);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
  );
  targets.forEach((t) => io.observe(t));
}

/* ---- The "A" mark travels down a track as the page scrolls: signature element ---- */
function initScrollMarker() {
  const marker = document.querySelector('.scroll-marker');
  const fill = document.querySelector('.scroll-marker__fill');
  if (!marker || !fill) return;

  const setProgress = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - doc.clientHeight;
    const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
    fill.style.height = `${pct}%`;
    marker.classList.toggle('is-active', window.scrollY > 40);
  };

  window.addEventListener('scroll', setProgress, { passive: true });
  setProgress();
}

/* ---- Slow parallax scale on the hero image, driven by scroll instead of just load ---- */
function initHeroParallax() {
  const media = document.querySelector('.hero__media img');
  if (!media) return;
  const onScroll = () => {
    const y = Math.min(window.scrollY, 600);
    media.style.transform = `scale(${1 + y * 0.00025}) translateY(${y * 0.08}px)`;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ---- Cart drawer open/close (static demo state — wire to real cart on integration) ---- */
function initCartDrawer() {
  const drawer = document.querySelector('.attitude-cart-drawer');
  const scrim = document.querySelector('.attitude-cart-scrim');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');
  if (!drawer) return;

  const open = () => { drawer.classList.add('is-open'); scrim.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.classList.remove('is-open'); scrim.classList.remove('is-open'); document.body.style.overflow = ''; };

  openers.forEach((el) => el.addEventListener('click', open));
  closers.forEach((el) => el.addEventListener('click', close));
  scrim && scrim.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* ---- Re-render the drawer body from a Shopify cart.js object (used after
     an AJAX add-to-cart on the product page, no page reload) ---- */
  function render(cart) {
    document.querySelectorAll('.nav__cart-count').forEach((el) => {
      el.textContent = cart.item_count;
    });

    const body = drawer.querySelector('.attitude-cart-drawer__empty, .attitude-cart-drawer__items');
    if (!body) return;

    if (cart.item_count === 0) {
      body.outerHTML =
        '<div class="attitude-cart-drawer__empty">' +
        '<p data-i18n="cart_empty">Il tuo carrello è vuoto.</p>' +
        '<a href="#collezione" class="btn btn--ghost" data-cart-close data-i18n="cart_continue">Continua lo shopping</a>' +
        '</div>';
    } else {
      const rows = cart.items.map((item) => {
        const lineTotal = (item.final_line_price / 100).toFixed(2).replace('.', ',');
        return '<div class="attitude-cart-drawer__item"><span>' + item.product_title + ' × ' + item.quantity +
          '</span><span>€' + lineTotal + '</span></div>';
      }).join('');
      body.outerHTML =
        '<div class="attitude-cart-drawer__items">' + rows +
        '<a href="/cart" class="btn btn--primary" style="margin-top:1rem;">Vai al carrello</a></div>';
    }
    // il pulsante "chiudi" nella testata del drawer non viene toccato dal
    // replace, quindi resta funzionante senza dover riattaccare listener
  }

  window.AttitudeCart = { open, close, render };
}

function initYear() {
  const el = document.querySelector('[data-year]');
  if (el) el.textContent = new Date().getFullYear();
}
